import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["fieldType"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CardSmartProperty } from './CardSmartProperty';
import { HtmlFileIcon } from 'foundations-assets/icons/components/HtmlFileIcon';
import { TextDataTypeIcon } from 'foundations-assets/icons/components/TextDataTypeIcon';
import { NumericDataTypeIcon } from 'foundations-assets/icons/components/NumericDataTypeIcon';
import { DateDataTypeIcon } from 'foundations-assets/icons/components/DateDataTypeIcon';
import { FileIcon } from 'foundations-assets/icons/components/FileIcon';
import { CallingIcon } from 'foundations-assets/icons/components/CallingIcon';
import { EnumerationDataTypeIcon } from 'foundations-assets/icons/components/EnumerationDataTypeIcon';
import { QuestionAnswerIcon } from 'foundations-assets/icons/components/QuestionAnswerIcon';
import { jsx as _jsx } from "react/jsx-runtime";
const fieldTypeIcons = {
  text: /*#__PURE__*/_jsx(TextDataTypeIcon, {}),
  number: /*#__PURE__*/_jsx(NumericDataTypeIcon, {}),
  date: /*#__PURE__*/_jsx(DateDataTypeIcon, {}),
  booleancheckbox: /*#__PURE__*/_jsx(EnumerationDataTypeIcon, {}),
  checkbox: /*#__PURE__*/_jsx(EnumerationDataTypeIcon, {}),
  file: /*#__PURE__*/_jsx(FileIcon, {}),
  phonenumber: /*#__PURE__*/_jsx(CallingIcon, {}),
  radio: /*#__PURE__*/_jsx(EnumerationDataTypeIcon, {}),
  select: /*#__PURE__*/_jsx(EnumerationDataTypeIcon, {}),
  textarea: /*#__PURE__*/_jsx(TextDataTypeIcon, {}),
  calculation_equation: /*#__PURE__*/_jsx(NumericDataTypeIcon, {}),
  calculation_rollup: /*#__PURE__*/_jsx(NumericDataTypeIcon, {}),
  calculation_score: /*#__PURE__*/_jsx(NumericDataTypeIcon, {}),
  calculation_read_time: /*#__PURE__*/_jsx(NumericDataTypeIcon, {}),
  unknown: /*#__PURE__*/_jsx(QuestionAnswerIcon, {}),
  html: /*#__PURE__*/_jsx(HtmlFileIcon, {})
};
const fieldTypeLabels = {
  text: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "smartPropertyTemplates.labels.text"
  }),
  number: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "smartPropertyTemplates.labels.number"
  }),
  date: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "smartPropertyTemplates.labels.date"
  }),
  checkbox: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "smartPropertyTemplates.labels.checkbox"
  }),
  file: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "smartPropertyTemplates.labels.file"
  }),
  booleancheckbox: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "smartPropertyTemplates.labels.checkbox"
  }),
  phonenumber: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "smartPropertyTemplates.labels.phonenumber"
  }),
  radio: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "smartPropertyTemplates.labels.radio"
  }),
  select: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "smartPropertyTemplates.labels.select"
  }),
  textarea: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "smartPropertyTemplates.labels.textarea"
  }),
  calculation_equation: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "smartPropertyTemplates.labels.calculation_equation"
  }),
  calculation_rollup: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "smartPropertyTemplates.labels.calculation_rollup"
  }),
  calculation_score: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "smartPropertyTemplates.labels.calculation_score"
  }),
  calculation_read_time: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "smartPropertyTemplates.labels.calculation_read_time"
  }),
  unknown: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "smartPropertyTemplates.labels.unknown"
  }),
  html: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "smartPropertyTemplates.labels.html"
  })
};
export const LabelFieldType = _ref => {
  let {
      fieldType
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(CardSmartProperty.PropertyLabel, Object.assign({}, rest, {
    icon: fieldTypeIcons[fieldType],
    children: fieldTypeLabels[fieldType]
  }));
};